import React from "react";
import VideoCVMain from "../../components/video-cv/VideoCVMain";
import Footer from "src/components/common/Footer";
import { RODEO_PAGE_NAME } from "src/_config/site_statics";
import Sidebar from "src/components/common/Sidebar";
import Header from "src/components/common/Header";

const VideoCV: React.FC = () => {
  return <>
        <Header variant="topbar" />
        <Sidebar page={RODEO_PAGE_NAME.ADD_MEMBER} />
        <VideoCVMain />
        <Footer variant="dashboard" />
      </>;
};

export default VideoCV;